import { render, staticRenderFns } from "./BillingPeriodMessage.vue?vue&type=template&id=6275aee1&scoped=true&"
import script from "./BillingPeriodMessage.vue?vue&type=script&lang=js&"
export * from "./BillingPeriodMessage.vue?vue&type=script&lang=js&"
import style0 from "./BillingPeriodMessage.vue?vue&type=style&index=0&id=6275aee1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6275aee1",
  null
  
)

export default component.exports